import styles from "./SignUpModal.module.css";
import { useState, ChangeEvent } from "react";

/**
 * @author kmy
 * @date 2025-03-24
 * @remark 개인정보 수집 및 이용 동의 모달
 *
 * 개인정보처리 페이지 생성을 위해 Prop를 모두 옵셔널로 바꾸고 PrivacyScreen에 연결 | 251215 | smyun
 */

interface PrivacyModalProps {
    onClose?: () => void;
    checkBoxClicked?: (e: ChangeEvent<HTMLInputElement>) => void;
    isAccepted?: boolean;
}


const PrivacyModal: React.FC<PrivacyModalProps> = ({ onClose, checkBoxClicked, isAccepted }) => {

    const [accepted, setAccepted] = useState(isAccepted);
    const clickHandler = (e: ChangeEvent<HTMLInputElement>) => {
        checkBoxClicked && checkBoxClicked(e); 
        setAccepted((prevAccepted) => !prevAccepted); 
    }

    return (
        <div className={styles.modal_contents}>
            <div className={styles.scroll_bx}>
                <p>(주)한국공간정보통신의 ('https://modoomap.com'이하 '모두의 지도')는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.</p>

                <br />

                <p>모두의 지도는 개인정보 처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</p>

                <br />

                <p>* 본 방침은 2021년 8월 10일부터 시행됩니다. </p>

                <br />

                <p>제 1조 (개인정보의 처리 목적)</p>

                <br />

                <p>모두의 지도는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>

                <br />

                <p>(가) 홈페이지 회원가입 및 관리</p>
                <p>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지·통지 목적으로 개인정보를 처리합니다.</p>

                <br />

                <p>(나) 재화 또는 서비스 제공</p>
                <p>서비스 제공, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 요금결제·정산을 목적으로 개인정보를 처리합니다.</p>

                <br />

                <p>제 2조 (개인정보의 처리 및 보유 기간)</p>

                <br />

                <p>1. (주)한국공간정보통신은 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>

                <br />

                <p>2. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>

                <br />

                <p>(1) 홈페이지 회원가입 및 관리</p>
                <p>홈페이지 회원가입 및 관리와 관련한 개인정보는 수집.이용에 관한 동의일로부터 회원 유지 기간까지 위 이용목적을 위하여 보유.이용됩니다.</p>
                <p>보유근거 : 정보 주체의 동의</p>
                <p>관련법령 : </p>
                <p>1) 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년</p>
                <p>2) 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년</p>
                <p>3) 대금결제 및 재화 등의 공급에 관한 기록 : 5년</p>
                <p>4) 계약 또는 청약철회 등에 관한 기록 : 5년</p>
                <p>5) 표시/광고에 관한 기록 : 6개월</p>

                <br />

                <p>제 3조 (정보주체와 법정대리인의 권리·의무 및 그 행사방법)</p>

                <br />

                <p>1. 정보주체는 (주)한국공간정보통신에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</p>

                <br />

                <p>2. 제1항에 따른 권리 행사는 (주)한국공간정보통신에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 (주)한국공간정보통신은 이에 대해 즉시 조치하겠습니다.</p>

                <br />

                <p>3. 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다.이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p>

                <br />

                <p>4. 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.</p>

                <br />

                <p>5. 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>

                <br />

                <p>(주)한국공간정보통신은 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</p>

                <br />

                <p>제 4조 (처리하는 개인정보의 항목 작성)</p>

                <br />

                <p>1. (주)한국공간정보통신은 다음의 개인정보 항목을 처리하고 있습니다.</p>

                <br />

                <p>(1) 홈페이지 회원가입 및 관리</p>
                <p>필수항목 : 이메일, 비밀번호, 성별, 생년월일, 포털 로그인의 경우 - 닉네임</p>

                <br />

                <p>제 5조 (개인정보의 파기)</p>

                <br />

                <p>1. (주)한국공간정보통신은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 즉시 해당 개인정보를 파기합니다.</p>

                <br />

                <p>2. 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>

                <br />

                <p>3. 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>

                <br />

                <p>■ 파기절차</p>
                <p>(주)한국공간정보통신은 파기 사유가 발생한 개인정보를 선정하고, (주)한국공간정보통신의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</p>

                <br />

                <p>■ 파기기한</p>
                <p>이용자의 개인정보는 개인정보의 보유 기간이 지난 경우에는 보유 기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.</p>

                <br />

                <p>■ 파기방법</p>
                <p>전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</p>

                <br />

                <p>제6조(개인정보의 안전성 확보 조치)</p>

                <br />

                <p>(주)한국공간정보통신은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>

                <br />

                <p>1. 개인정보 취급 직원의 최소화 및 교육</p>
                <p>개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.</p>

                <br />

                <p>2. 내부관리계획의 수립 및 시행</p>
                <p>개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.</p>

                <br />

                <p>3. 개인정보의 암호화</p>
                <p>이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.</p>

                <br />

                <p>4. 개인정보에 대한 접근 제한</p>
                <p>개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있습니다.</p>

                <br />

                <p>5. 문서보안을 위한 잠금장치 사용</p>
                <p>개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.</p>

                <br />

                <p>6. 비인가자에 대한 출입 통제</p>
                <p>개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.</p>

                <br />

                <p>제 7조 (개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항)</p>

                <br />

                <p>1. (주)한국공간정보통신은 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</p>
                <p>2. 쿠키는 웹 사이트를 운영하는데 이용되는 서버(https)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.</p>
                <p>(1) 쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</p>
                <p>(2) 쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구&gt;인터넷 옵션&gt;개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.</p>
                <p>(3) 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>

                <br />

                <p>제 8조 (개인정보 보호책임자)</p>

                <br />

                <p>1. (주)한국공간정보통신은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>

                <br />

                <p>▶ 개인정보 보호책임자</p>
                <p>성명 :김인현</p>
                <p>직책 :관리자</p>
                <p>직급 :CEO</p>
                <p>연락처 :+82.2.576.7070, moamap@ksic.net, +82.2.576.0578</p>
                <p>※ 개인정보 보호 담당부서로 연결됩니다.</p>

                <br />

                <p>2. 정보 주체께서는 (주)한국공간정보통신의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. (주)한국공간정보통신은 정보주체의 문의에 대해 즉시 답변 및 처리해드릴 것입니다.</p>

                <br />

                <p>제 9조(개인정보 처리방침 변경)</p>

                <br />

                <p>이 개인정보처리방침은 2021년 8월 10부터 적용됩니다. 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항 또는 개인정보로 수집한 이메일을 통하여 고지됩니다.</p>
            </div>
            {isAccepted !== undefined && (
	            <div className={`${styles.accept_container} ${styles.row}`}>
	                <label>
	                    <input
	                        type="checkbox"
	                        name="privacyAccepted"
	                        onChange={clickHandler}
	                        checked={accepted}
	                    />
	                    위 약관의 내용을 숙지했으며, 이에 동의합니다.
	                </label>
	            </div>
             )}
        </div>
    );
}

export default PrivacyModal;
